<div
  [class]="'tag__' + tag"
  class="tag"
>
  {{ tag }}
</div>
